import { gql } from "@apollo/client";


export const ATTENDANCE_SCAN = gql`
    mutation AttendanceScan($input: AttendanceScanInput!) {
        attendanceScan(input: $input) {
            result
            reason
            detail
            server_time
            attendance_shift_id
        }
    }
`;
